import { DOCUMENT } from '@config/constants';

export const styles = {
  alert: {
    display: 'flex',
    variant: 'subtle',
    borderRadius: 'lg',
    alignItems: 'center',
    padding: '0.82rem 1rem',
  },
  [DOCUMENT.ANALYST_STATUS.APPROVED]: {
    status: 'info',
  },
  [DOCUMENT.ANALYST_STATUS.PENDING]: {
    status: 'success',
  },
  warning: {
    status: 'warning',
  },
  alertIcon: {
    boxSize: '5',
    marginRight: '2',
  },
  alertTitle: {
    dir: 'rtl',
    fontSize: 'md',
    maxWidth: '3xs',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginRight: 'auto',
    fontWeight: '500',
  },
  alertDescription: {
    fontSize: 'sm',
    marginLeft: 'auto',
  },
  processing: {
    fontSize: 'sm',
    marginLeft: '4',
    marginRight: '1',
    colorScheme: 'yellow',
    variant: 'solid',
  },
  descriptionBox: {
    marginLeft: 'auto',
  },
  iconButton: {
    size: 'sm',
    variant: 'ghost',
  },
};
